export default __webpack_public_path__ + "static/media/bpt.1e4d99d5.svg";